<template>
  <div id="productModal" class="modal">
    <!-- Modal content -->
    <div class="modal-content">
      <div class="row">
        <div class="col-md-3 mt-5">
          <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <a class="btn btn-primary btn-block" id="v-product-data-tab" data-toggle="pill" href="#v-product-data"
               role="tab" aria-controls="product-home" aria-selected="true">{{ $t('page.product.view.data') }}</a>
            <a class="btn btn-primary btn-block" id="v-product-media-assets-tab" data-toggle="pill"
               href="#v-product-media-assets" role="tab" aria-controls="product-media-assets"
               aria-selected="false">{{ $t('page.product.view.media_assets_header') }}</a>
            <a class="btn btn-primary btn-block" id="v-product-description-tab" data-toggle="pill"
               href="#v-product-description" role="tab" aria-controls="product-description"
               aria-selected="false">{{ $t('page.product.view.description_header') }}</a>
            <a class="btn btn-primary btn-block" id="v-product-attributes-tab" data-toggle="pill"
               href="#v-product-attributes" role="tab" aria-controls="product-attributes"
               aria-selected="false">{{ $t('page.product.view.attributes') }}</a>
            <a class="btn btn-primary btn-block" id="v-product-stock-tab" data-toggle="pill" href="#v-product-stock"
               role="tab" aria-controls="product-stock" aria-selected="false">{{ $t('page.product.view.stock') }}</a>
            <a class="btn btn-primary btn-block" id="v-product-category-tab" data-toggle="pill"
               href="#v-product-category" role="tab" aria-controls="product-category"
               aria-selected="false">{{ $t('page.product.view.category') }}</a>
            <a class="btn btn-primary btn-block" id="v-product-relations-tab" data-toggle="pill"
               href="#v-product-relations" role="tab" aria-controls="product-relations"
               aria-selected="false">{{ $t('page.product.view.relations') }}</a>
            <a class="btn btn-primary btn-block" id="v-product-supplier-tab" data-toggle="pill"
               href="#v-product-supplier" role="tab" aria-controls="product-supplier"
               aria-selected="false">{{ $t('page.product.view.supplier_header') }}</a>
            <a class="btn btn-primary btn-block" id="v-product-connectors-tab" data-toggle="pill"
               href="#v-product-connectors" role="tab" aria-controls="product-connectors"
               aria-selected="false">{{ $t('page.product.view.connectors_header') }}</a>
          </div>
        </div>

        <div class="col-md-9">
          <div class="tab-content" id="v-product-tabContent">
            <div class="tab-pane fade active in" id="v-product-data" role="tabpanel"
                 aria-labelledby="v-product-data-tab">
              <div class="row"><label>SKU</label><input class="form-control" type="text" id="product_sku_u"
                                                        placeholder="SKU" v-model="product.sku"/></div>
              <div class="row"><label>ALT_SKU</label> <input class="form-control" type="text" id="product_alt_sku_u"
                                                             placeholder="ALT_SKU" v-model="product.sku_alternative"/>
              </div>
              <div class="row"><label>EAN</label><input class="form-control" type="text" id="product_ean_u"
                                                        placeholder="EAN" v-model="product.ean"/></div>
              <div class="row"><label>Name</label><input class="form-control" type="text" id="product_name_u"
                                                         placeholder="Name" v-model="product.name"/></div>
              <div class="row"><label>{{ $t('page.product.view.manufacturer') }}</label> <input class="form-control"
                                                                                                type="text"
                                                                                                id="product_manufacturer_u"
                                                                                                :placeholder="$t('page.product.view.manufacturer')"
                                                                                                v-model="product.manufacturer"/>
              </div>
              <div class="row"><label>{{ $t('page.product.view.comanufacturer') }}</label><input class="form-control"
                                                                                                 type="text"
                                                                                                 id="product_comanufacturer_u"
                                                                                                 :placeholder="$t('page.product.view.comanufacturer')"
                                                                                                 v-model="product.country_of_manufacture"/>
              </div>
              <div class="row"><label>{{ $t('page.product.view.commodity_code') }}</label><input class="form-control"
                                                                                                 type="text"
                                                                                                 id="product_commodityCode_u"
                                                                                                 :placeholder="$t('page.product.view.commodity_code')"
                                                                                                 v-model="product.commodity_code"/>
              </div>
              <div class="row"><label>{{ $t('page.product.view.weight') }}</label><input class="form-control"
                                                                                         type="text"
                                                                                         id="product_weight_u"
                                                                                         :placeholder="$t('page.product.view.weight')"
                                                                                         v-model="product.weight"/>
              </div>
              <div class="row"><label>{{ $t('page.product.view.width') }}</label><input class="form-control" type="text"
                                                                                        id="product_width_u"
                                                                                        :placeholder="$t('page.product.view.width')"
                                                                                        v-model="product.width"/></div>
              <div class="row"><label>{{ $t('page.product.view.height') }}</label><input class="form-control"
                                                                                         type="text"
                                                                                         id="product_height_u"
                                                                                         :placeholder="$t('page.product.view.height')"
                                                                                         v-model="product.height"/>
              </div>
              <div class="row"><label>{{ $t('page.product.view.length') }}</label><input class="form-control"
                                                                                         type="text"
                                                                                         id="product_length_u"
                                                                                         :placeholder="$t('page.product.view.length')"
                                                                                         v-model="product.length"/>
              </div>
              <div class="row"><label>{{ $t('page.product.view.status') }}</label>
                <select class="form-control" id="product_status_u" v-model="product.status"
                        :placeholder="$t('page.product.view.status')">
                  <option v-for="status in statuses" :value="status.value">{{ status.name }}</option>
                </select>
              </div>


              <div class="row"><label>{{ $t('page.product.view.price_gros') }}</label><input class="form-control"
                                                                                             type="text"
                                                                                             id="product_price_gros_u"
                                                                                             :placeholder="$t('page.product.view.price_gros')"
                                                                                             v-model="product.price_gros"/>
              </div>
              <div class="row"><label>{{ $t('page.product.view.price_net') }}</label><input class="form-control"
                                                                                            type="text"
                                                                                            id="product_price_net_u"
                                                                                            :placeholder="$t('page.product.view.price_net')"
                                                                                            v-model="product.price_net"/>
              </div>
              <div class="row"><label>{{ $t('page.product.view.abteilung') }}</label>
                <select class="form-control" id="product_abteilung_u" v-model="product.abteilung_id"
                        :placeholder="$t('page.product.view.abteilung')">
                  <option v-for="abteilung in abteilungen" :value="abteilung.id">{{ abteilung.name }}</option>
                </select>
              </div>
            </div>

            <div class="tab-pane fade in" id="v-product-media-assets" role="tabpanel"
                 aria-labelledby="v-product-media-assets-tab">
              <div class="row">
                <product-media-assets ref="productMediaAssets" v-model="product.mediaAssets"></product-media-assets>
              </div>
            </div>

            <div class="tab-pane fade in" id="v-product-description" role="tabpanel"
                 aria-labelledby="v-product-description-tab">
              <div class="row">
                <label>{{ $t('page.product.view.description_header') }}</label>
                <textarea v-model="product.description">{{ product.description }}</textarea>
              </div>
            </div>

            <div class="tab-pane fade in" id="v-product-attributes" role="tabpanel"
                 aria-labelledby="v-product-attributes-tab">
              <div class="row">
                <div class="col-md-12">
                  <h3>{{ $t('page.product.view.attributes') }}</h3>
                  <table class="table table-responsive">
                    <thead>
                    <th>{{ $t('page.product.view.attribute') }}</th>
                    <th>{{ $t('page.product.view.value') }}</th>
                    </thead>
                    <tbody>
                    <tr v-for="(attribute, index) in attributes">
                      <td>{{ attribute.name }}</td>
                      <td><input class="form-control"
                                 type="text"
                                 id="product_price_net_u"
                                 :placeholder="attribute.name"
                                 v-model="attribute.value"/></td>
                    </tr>
                    </tbody>
                  </table>
                  <p style="font-weight: bold;">
                    neues Attribut hinzufügen:
                  </p>
                  <div style="display: flex; justify-content: space-between; gap: 16px;">
                    <input class="form-control"
                           placeholder="attribute name" v-model="newAttributeName"/>
                    <button class="form-control" @click="addAttribute(newAttributeName)">
                      hinzufügen
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="v-product-stock" role="tabpanel" aria-labelledby="v-product-stock-tab">
              <div class="row">
                <div class="col-md-12">
                  <table class="table table-responsive">
                    <thead>
                    <th class="table-icon">
                      <div class="glyphicon glyphicon-cog"></div>
                    </th>
                    <th>{{ $t('page.product.view.storage') }}</th>
                    <th>{{ $t('page.product.view.rack') }}</th>
                    <th>{{ $t('page.product.view.storage_place') }}</th>
                    <th>{{ $t('page.product.view.stock') }}</th>
                    <th>{{ $t('page.product.view.stock_reserved') }}</th>
                    <th>{{ $t('page.product.view.stock_net') }}</th>
                    <th>{{ $t('page.product.view.reorder_level') }}</th>
                    <th>{{ $t('page.product.view.packaging_type') }}</th>
                    <th>{{ $t('page.product.view.wrapping_factor') }}</th>
                    <th>{{ $t('page.product.view.rebook') }}</th>
                    </thead>
                    <tbody id="product_reorder_level_u">
                    <tr v-for="(item, index) in reorderLevel">
                      <td>
                        <button type="button" class="form-control">
                          <span class="glyphicon glyphicon glyphicon-pencil" @click="editStock(index)"></span>
                        </button>
                      </td>
                      <td>{{ item.storage }}</td>
                      <td>{{ item.rack }}</td>
                      <td>{{ item.storagePlace }}</td>
                      <td><input type="text" class="form-control" ref="stock_edit_input" v-model="item.stock" readonly>
                      </td>
                      <td><a v-if="item.stockReserved > 0" href="#"
                             @click="openReservedOrders(item.stockId)">{{ item.stockReserved }}</a></td>
                      <td>{{ item.stock - item.stockReserved }}</td>
                      <td><input type="text" class="form-control" ref="min_stock_edit_input"
                                 v-model="item.reorder_level" readonly></td>
                      <td>
                        <button type="button" class="form-control" @click="openRebook(index)">
                          {{ $t('page.product.view.rebook') }}
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <edit-stock-modal ref="editStockModal"></edit-stock-modal>
                  <reserved-orders-modal ref="reservedOrdersModal" id="reservedOrdersModal"></reserved-orders-modal>
                  <rebook-modal :id="'rebookModal'" ref="rebookModal"
                                v-on:changedProduct="loadProduct(product.id)"></rebook-modal>
                </div>
                <div class="col-md-12">
                  <label for="inventory_management">{{ $t('page.product.view.inventory_management') }}</label>
                  <div class="form-control">
                    <input type="checkbox" id="inventory_management" name="inventory_management"
                           v-model="product['inventory_management']"
                           :checked="this.product['inventory_management'] === true"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="v-product-category" role="tabpanel" aria-labelledby="v-product-category-tab">
              <div class="row">
                <div class="col-md-12">
                  <h3>{{ $t('page.product.view.category') }}</h3>
                  <div class="form-control" v-for="category in categories">
                    <input type="checkbox" name="category[]" v-model="category.checked"
                           :checked="checkContainsCategory(category)"> {{ category.name }}
                  </div>
                  <!--div class="form-control" v-for="category in productTags">
                      <input type="checkbox" name="category[]" v-model="category.checked" :checked="checkContainsCategory(category)"> {{category.name}}
                  </div-->
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="v-product-relations" role="tabpanel"
                 aria-labelledby="v-product-relations-tab">
              <div class="row">
                <div class="col-md-12">
                  <h3>{{ $t('page.product.view.variation_header') }}</h3>
                  <table class="table table-responsive">
                    <thead>
                    <th class="table-icon">
                      <div class="glyphicon glyphicon-cog"></div>
                    </th>
                    <th>{{ $t('page.product.view.sku') }}</th>
                    <th>{{ $t('page.product.view.name') }}</th>
                    <th>{{ $t('page.product.view.stock') }}</th>
                    </thead>
                    <tbody id="product_variation_table">
                    <tr v-for="(variationItem, index) in relationVariations">
                      <td>
                        <button type="button" class="form-control" @click="openVariationModal(index)">
                          <span class="glyphicon glyphicon glyphicon-trash"></span>
                        </button>
                      </td>
                      <td>{{ variationItem.sku }}</td>
                      <td>{{ variationItem.name }}
                        <ul>
                          <li v-for="attribute in variationItem.attributes">{{ attribute.name }}:
                            {{ attribute.value }}
                          </li>
                        </ul>
                      </td>
                      <td>{{ variationItem.stock }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-md-3 col-md-offset-9">
                  <edit-relation-modal :id="'variation_relation'" :is-bundle="false"></edit-relation-modal>
                  <button type="button" class="form-control btn-primary" data-toggle="modal"
                          data-target="#variation_relation">{{ $t('page.product.view.add') }}
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <h3>{{ $t('page.product.view.bundle_header') }}</h3>
                  <table class="table table-responsive">
                    <thead>
                    <th class="table-icon">
                      <div class="glyphicon glyphicon-cog"></div>
                    </th>
                    <th>{{ $t('page.product.view.sku') }}</th>
                    <th>{{ $t('page.product.view.name') }}</th>
                    <th>{{ $t('page.product.view.quantity') }}</th>
                    </thead>
                    <tbody id="product_bundle_table">
                    <tr v-for="(bundleItem, index) in relationBundle">
                      <td>
                        <button type="button" class="form-control">
                          <span class="glyphicon glyphicon glyphicon-trash" @click="openBundleModal(index)"></span>
                        </button>
                        <button type="button" class="form-control" @click="editBundleModal(index)">
                          <span class="glyphicon glyphicon-pencil"></span>
                        </button>
                      </td>
                      <td>{{ bundleItem.sku }}</td>
                      <td>{{ bundleItem.name }}
                        <ul>
                          <li v-for="attribute in bundleItem.attributes">{{ attribute.name }}: {{ attribute.value }}
                          </li>
                        </ul>
                      </td>
                      <td>{{ bundleItem.quantity }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-md-3 col-md-offset-9">
                  <edit-relation-modal :id="'bundle_relation'" :is-bundle="true" @save="save"></edit-relation-modal>
                  <button type="button" class="form-control btn-primary" data-toggle="modal"
                          data-target="#bundle_relation">{{ $t('page.product.view.add') }}
                  </button>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="v-product-supplier" role="tabpanel" aria-labelledby="v-product-supplier-tab">
              <div class="row">
                <div class="col-md-12">
                  <h3>{{ $t('page.product.view.supplier_header') }}</h3>
                  <div class="row">
                    <div class="col-md-offset-8 col-md-4">
                      <select class="form-control mb-5" v-model="selectedSupplier">
                        <option value="-1">{{ $t('page.product.view.supplier_standard') }}</option>
                        <option v-for="supplier in suppliers" :value="supplier.id">{{ supplier.name }}</option>
                      </select>
                    </div>
                  </div>
                  <table class="table table-responsive">
                    <thead>
                    <th class="table-icon">
                      <div class="glyphicon glyphicon-cog"></div>
                    </th>
                    <th>{{ $t('page.product.view.supplier') }}</th>
                    <th>{{ $t('page.product.view.delivery_time') }}</th>
                    </thead>
                    <tbody id="product_supplier_table">
                    <tr v-for="supplier in suppliers">
                      <td></td>
                      <td>{{ supplier.name }}</td>
                      <td>{{ supplier.delivery_time }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-md-3 col-md-offset-9">
                  <add-supplier-modal :id="'add_supplier'" ref="add_supplier_modal"
                                      @save="addSupplier"></add-supplier-modal>
                  <button type="button" class="form-control btn-primary" data-toggle="modal" data-target="#add_supplier"
                          @click="loadSuppliers">{{ $t('page.product.view.add') }}
                  </button>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="v-product-connectors" role="tabpanel"
                 aria-labelledby="v-product-connectors-tab">
              <div class="row">
                <div class="col-md-12">
                  <ul class="nav nav-tabs">
                    <li v-for="(connector, index) in this.$connectors" :class="{active: (index === 0)}">
                      <a :href="'#'+connector.name" data-toggle="tab" :id="connector.name+'-tab'"
                         role="tab" :aria-controls="connector.name">
                        {{ (connector.title) ? connector.title : 's' }}
                      </a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane fade-in" :class="{active: (index === 0)}" :id="connector.name"
                         v-for="(connector, index) in this.$connectors" role="tabpanel">
                      <div class="panel panel-default mt-4">
                        <div class="panel-heading">
                          <h3 class="panel-title">{{ connector.title }} $t('page.product.view.interface')</h3>
                          <!-- todo: i18n -->
                        </div>
                        <div class="panel-body">
                          <component :is="connector" ref="connectors"></component>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5">
            <button type="button" id="product_create_btn_u" class="form-control" v-on:click="productUpdate()">
              {{ $t('page.product.view.update') }}
            </button>
            <input type="hidden" id="hidden_update_field" value="" name="hidden_update_field"/>
          </div>
        </div>
      </div>
    </div>

    <question-modal :id="'deleteVariationModal'" :title="modalTitle" :message="modalMessage" @yes="deleteRelation(true)"
                    @no="deleteRelation(false)"></question-modal>
    <question-modal :id="'deleteBundleModal'" :title="modalTitle" :message="modalMessage" @yes="deleteRelation(true)"
                    @no="deleteRelation(false)"></question-modal>

  </div>
</template>
<script>
import EditRelationModal from './EditRelationModal'
import AddSupplierModal from "./AddSupplierModal";
import EditStockModal from "./EditStockModal";
import ReservedOrdersModal from "./ReservedOrdersModal";
import ProductMediaAssets from "./ProductMediaAssets";
import Vue from 'vue';

export default {
  name: "ProductModal",
  private: {
    delVariationIndex: Number,
    delBundleIndex: Number,
  },
  components: {
    ProductMediaAssets,
    ReservedOrdersModal,
    AddSupplierModal,
    EditRelationModal,
    EditStockModal,
  },
  data: function () {
    return {
      newAttributeName: '',
      product: {},
      reorderLevel: [],
      relationVariations: [],
      relationBundle: [],
      categories: [],
      attributes: [],
      suppliers: [],
      abteilungen: [],
      packagingTypes: [],
      selectedSupplier: -1,
      modalTitle: "",
      modalMessage: "",
      rerenderStockKey: 0,
      statuses: [
        {name: "Aktiv", value: "active"},
        {name: "Archiviert", value: "archive"},
      ]
    }
  },
  props: {
    productTags: Array,
  },
  beforeMount: function () {
    this.productTags.forEach(function (item) {
      this.categories.push({
        id: item.id,
        name: item.name,
        checked: false,
      });
    });

    axios.get('/manage/abteilung/list')
        .then((response) => {
          response.data.forEach((item) => {
            this.abteilungen.push({
              id: item.id,
              name: item.name
            })
          });
        });

    axios.get('/article/packaging_types')
        .then((response) => {
          response.data.forEach((item) => {
            this.packagingTypes.push({
              id: item.id,
              name: item.name
            })
          });
        });
  },
  mounted() {
    this.$refs.editStockModal.setPackagingTypes(this.packagingTypes);
  },
  methods: {
    addAttribute(name){
      this.attributes.push({
        name: name,
        value: ''
      })
      this.newAttributeName = '';
    },
    loadProduct: function (id) {
      Vue.set(this.product, 'id', id);

      this.loadShopConnectors(this.product.id);

      // for new Products
      if (id === -1) {
        this.product = {
          id: -1,
          mediaAssets: []
        };
        this.selectedSupplier = -1;
        this.reorderLevel = [];
        this.relationVariations = [];
        this.relationBundle = [];
        this.attributes = [];
        this.suppliers = [];

        return;
      }

      axios.get('/article/get_article/' + id)
          .then((response) => {
            let data = response["data"];

            Vue.set(this.product, 'sku', data["sku"]);
            Vue.set(this.product, 'sku_alternative', data["sku_alternative"]);
            Vue.set(this.product, 'ean', data["ean"]);
            Vue.set(this.product, 'name', data["name"]);
            Vue.set(this.product, 'manufacturer', data["manufacturer"]);
            Vue.set(this.product, 'country_of_manufacture', data["country_of_manufacture"]);
            Vue.set(this.product, 'commodity_code', data["commodity_code"]);
            Vue.set(this.product, 'weight', data["weight"]);
            Vue.set(this.product, 'width', data["width"]);
            Vue.set(this.product, 'height', data["height"]);
            Vue.set(this.product, 'length', data["length"]);
            Vue.set(this.product, 'status', data["status"]);
            Vue.set(this.product, 'price_gros', data["price_gros"]);
            Vue.set(this.product, 'price_net', data["price_net"]);
            Vue.set(this.product, 'inventory_management', data["inventory_management"]);
            Vue.set(this.product, 'abteilung_id', data["abteilung_id"]);

            this.product.mediaAssets = [];
            this.selectedSupplier = -1;
            this.reorderLevel = [];
            this.relationVariations = [];
            this.relationBundle = [];
            this.attributes = [];
            this.suppliers = [];
            data["reorder_levels"].forEach((item) => {
              this.reorderLevel.push({
                storage: item["storage"],
                rack: item["rack"],
                storagePlace: item["storagePlace"],
                storagePlaceId: item["storagePlaceId"],
                stockId: item["stockId"],
                stock: item["stock"],
                stockReserved: item["stock_reserved"],
                reorder_level: item["reorder_level"],
                packaging_type: item["packaging_type"],
                wrapping_factor: parseFloat(item["wrapping_factor"]),
              });
            });


            data["variations"].forEach((item) => {
              let attributes = [];
              item["attributes"].forEach((attribute) => {
                attributes.push({
                  name: attribute["name"],
                  value: attribute["value"],
                });
              });
              this.relationVariations.push({
                sku: item["sku"],
                name: item["name"],
                stock: item["stock"],
                attributes: attributes,
              });
            });
            data["bundle"].forEach((item) => {
              let attributes = [];
              item["attributes"].forEach((attribute) => {
                attributes.push({
                  name: attribute["name"],
                  value: attribute["value"],
                });
              });
              this.relationBundle.push({
                sku: item["sku"],
                name: item["name"],
                quantity: item["quantity"],
                attributes: attributes,
              });
            });
            data["tags"].forEach((item) => {
              this.categories.forEach((category) => {
                if (category.id === item.id) {
                  category.checked = true;
                }
              });
            });
            data["attributes"].forEach((item) => {
              this.attributes.push({
                id: item.id,
                name: item.name,
                value: item.value,
              });
            });
            data["suppliers"].forEach((item) => {
              if (item.checked === true) {
                this.selectedSupplier = item.id;
              }

              this.suppliers.push({
                id: item.id,
                name: item.name,
                delivery_time: item.delivery_time,
              })
            });

            data["mediaAssets"].forEach((mediaAsset) => {
              this.product.mediaAssets.push({
                name: mediaAsset["name"],
                src: mediaAsset["url"],
                msrc: mediaAsset["url"],
                w: mediaAsset["width"],
                h: mediaAsset["height"]
              })
            })
          });
    },
    loadShopConnectors: function (id) {
      if (typeof (this.$refs["connectors"]) != "undefined") {
        this.$refs["connectors"].forEach(function (connector) {
          connector.loadProduct(id);
        })
      }
    },
    loadSuppliers: function () {
      this.$refs["add_supplier_modal"].loadSuppliers(this.suppliers);
    },
    addSupplier: function (supplier) {
      this.suppliers.push({
        id: supplier.id,
        name: supplier.name,
        delivery_time: 0,
      })
    },
    checkContainsCategory: function (category) {
      let contains = false;
      this.categories.forEach(function (item) {
        if (item.name === category.name) {
          contains = true;
        }
      });
      return contains;
    },

    openRebook: function (index) {
      let rebookModal = this.$refs["rebookModal"];
      rebookModal.setProductId(this.product.id);
      rebookModal.setMaxStock(this.reorderLevel[index].stock);
      rebookModal.setStoragePlaceId(this.reorderLevel[index].storagePlaceId);

      $('#rebookModal').modal("show");
    },
    openReservedOrders: function (index) {
      let reservedOrdersModal = this.$refs["reservedOrdersModal"];
      reservedOrdersModal.loadReservedOrders(index);

      $('#reservedOrdersModal').modal("show");
    },
    editVariationModal: function (index) {
      this.delVariationIndex = index;
      this.modalTitle = this.$t('page.product.view.delete_variant_relation_title');
      this.modalMessage = this.$t('page.product.view.delete_variant_relation');

      let productName = this.relationVariations[index].sku + " - " + this.relationVariations[index].name;
      this.relationVariations[index].attributes.forEach(function (attribute) {
        productName += " - " + attribute["name"] + ": " + attribute["value"];
      });

      $('#variation_relation').modal("show");
      $('#variation_relation input[name="product"]').val(productName);
    },
    editBundleModal: function (index) {
      this.delBundleIndex = index;
      this.modalTitle = this.$t('page.product.view.delete_bundle_relation_title');
      this.modalMessage = this.$t('page.product.view.delete_bundle_relation');

      let productName = this.relationBundle[index].sku + " - " + this.relationBundle[index].name;
      this.relationBundle[index].attributes.forEach(function (attribute) {
        productName += " - " + attribute["name"] + ": " + attribute["value"];
      });

      $('#bundle_relation').modal("show");
      $('#bundle_relation input[name="product"]').val(productName);
      $('#bundle_relation input[name="quantity"]').val(this.relationBundle[index].quantity);
    },
    openVariationModal: function (index) {
      this.delVariationIndex = index;
      this.modalTitle = this.$t('page.product.view.delete_variant_relation_title');
      this.modalMessage = this.$t('page.product.view.delete_variant_relation');

      $('#deleteVariationModal').modal("show");
    },
    openBundleModal: function (index) {
      this.delBundleIndex = index;
      this.modalTitle = this.$t('page.product.view.delete_bundle_relation_title');
      this.modalMessage = this.$t('page.product.view.delete_bundle_relation');

      $('#deleteBundleModal').modal("show");
    },
    deleteRelation: function (del) {
      if (del === true) {
        if (this.delVariationIndex != null) {
          this.$delete(this.relationVariations, this.delVariationIndex);
        } else if (this.delBundleIndex != null) {
          this.$delete(this.relationBundle, this.delBundleIndex);
        }
      }
      this.delBundleIndex = null;
      this.delVariationIndex = null;
    },
    getPackagingName: function (id) {
      let packagingName = "";
      this.packagingTypes.forEach(function (item) {
        if (item.id === id) {
          packagingName = item.name;
        }
      });

      return packagingName;
    },
    save: function (variant) {
      if (variant.type !== "bundle" && variant.type !== "configurable") {
        return;
      }

      let item = {};

      if (variant.type === "bundle") {
        item.bundle = [];
        if ($('#product_bundle_table tr').length === 0) {
          item.bundle.push({
            sku: variant.sku,
            quantity: variant.quantity,
          })
        }
        $('#product_bundle_table tr').each(function () {
          let sku = this.firstChild.nextElementSibling.firstChild.nodeValue.split(' - ', 2)[0];
          let quantity = this.lastElementChild.firstChild.nodeValue;
          item.bundle.push({
            sku: sku,
            quantity: quantity,
          })
        });

        if (item.bundle.length > 0) {
          item.bundle.push({
            sku: variant.sku,
            quantity: variant.quantity,
          });
        }
      } else if (variant.type === "configurable") {
        item.configurable = [];
        $('#product_variation_table tr').each(function () {
          let sku = this.firstChild.nextElementSibling.firstChild.nodeValue.split(' - ', 2)[0];

          item.configurable.push({sku: sku})
        });
        if (item.configurable.length > 0) {
          item.configurable.push({sku: variant.sku});
        }
      }

      axios.post('/article/update/' + this.product.id + '/' + variant.type, {
        item: item,
      }).then(function (data) {
        this.loadProduct(this.product.id);
      }).catch(function (exception) {

      });
    },
    editStock: function (item, index) {
      this.$refs.editStockModal.setItem(item, index);

      $('#editStockModal').modal("show");
    },
    updateStock: function (item, index) {
      this.reorderLevel[index] = item;
      this.rerenderStockKey++;
    },
    saveShopConnectors: function () {
      if (typeof (this.$refs["connectors"]) != "undefined") {
        this.$refs["connectors"].forEach(function (connector) {
          connector.saveProduct();
        })
      }
    },
    productUpdate: function () {
      let tags = [];
      this.categories.forEach(function (category) {
        if (category.checked === true) {
          tags.push(category);
        }
      });

      this.saveShopConnectors();

      axios.post('/article/update/' + this.product.id, {
        sku: this.product.sku,
        alt_sku: this.product.sku_alternative,
        ean: this.product.ean,
        name: this.product.name,
        manufacturer: this.product.manufacturer,
        comanufacturer: this.product.country_of_manufacture,
        commodity_code: this.product.commodity_code,
        weight: this.product.weight,
        attributes: this.attributes,
        width: this.product.width,
        height: this.product.height,
        length: this.product.length,
        status: this.product.status,
        price_gros: this.product.price_gros,
        price_net: this.product.price_net,
        inventory_management: this.product.inventory_management,
        abteilung_id: this.product.abteilung_id,
        categories: tags,
        supplier_standard_id: this.selectedSupplier,
        reorder_level: this.reorderLevel,
        media_assets: this.product.mediaAssets,
        bundle: this.relationBundle ? this.relationBundle : null
      }).then(function (data) {
        window.location.reload();
      }).catch(function (error) {
        console.log(error);
      });
    }

  }

}
</script>

<style scoped>
.table-icon {
  width: 30px;
}

.flex-column {
  display: flex;
  display: -webkit-flex;
  flex: 1 100%;
  flex-flow: column nowrap;
}
</style>